module.exports = __webpack_public_path__ + "img/gc_country_flag_va.5f9738e4.svg";